$(document).ready(function () {
  // Funkcija koja procesira klik/touch na strelicu
  function handleArrowInteraction(event) {
    // Zaustavlja sve druge događaje odmah na početku
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation(); // Ovo je ključno za sprečavanje da slick slajder preuzme kontrolu

    var sectionWrapper = $(this).closest(".section-wrapper");
    var additionalText = sectionWrapper.next(".additional-text-wrapper");

    if (additionalText.length > 0) {
      var arrowImage = $(this).find("img");
      if (arrowImage.attr("src").includes("arrow-down.svg")) {
        arrowImage.attr("src", "/images/arrow-up.svg");
      } else {
        arrowImage.attr("src", "/images/arrow-down.svg");
      }
      additionalText.toggleClass("active");

      // Dodatno osiguranje - nakon promene stanja sprečavamo da slick preuzme kontrolu
      return false;
    }
  }

  // Pomoćna funkcija za postavljanje event handler-a sa visokim prioritetom
  function setupHighPriorityHandler() {
    // Prvo uklanjamo sve postojeće hendlere da izbegnemo dupliranje
    $(".image-wrapper--arrow").off("click touchstart touchend");
    $(".image-wrapper--arrow img").off("click touchstart touchend");

    // Dodajemo hendlere sa većim prioritetom (koristimo direktno selektore umesto delegacije)
    $(".image-wrapper--arrow").on("click", handleArrowInteraction);
    $(".image-wrapper--arrow").on("touchstart", handleArrowInteraction);
    $(".image-wrapper--arrow img").on("click touchstart", function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      $(this).parent().trigger("click");
      return false;
    });
  }

  // Funkcija za inicijalizaciju koja se poziva u više situacija
  function initArrowHandlers() {
    // Postavljamo događaje za desktop verziju
    $(".single-new-card").on(
      "click",
      ".image-wrapper--arrow",
      handleArrowInteraction
    );

    // Specijalno za mobilne uređaje, postavljamo hendlere sa prioritetom
    if ($(window).width() < 1250) {
      setupHighPriorityHandler();
    }
  }

  // Inicijalna postavka
  initArrowHandlers();

  // Reagujemo i na promenu veličine ekrana
  $(window).on("resize", function () {
    if ($(window).width() < 1250) {
      setupHighPriorityHandler();
    }
  });

  // Dodatno, reagujemo i nakon inicijalizacije bilo kojeg slick slajdera
  $(document).on("afterChange", ".slick-initialized", function () {
    setupHighPriorityHandler();
  });

  // Specifično za TV stranice
  $(document).on("afterChange", ".tv_tariffs_packages_wrapper", function () {
    setupHighPriorityHandler();
  });

  // Specifično za stranice telefona
  if ($("#tarife-container--carousel").length > 0) {
    $("#tarife-container--carousel").on(
      "click",
      ".image-wrapper--arrow",
      handleArrowInteraction
    );

    // Posebno ciljamo arrows u slajderu telefona
    $("#tarife-container--carousel .cards-section-carousel").on(
      "afterChange",
      function () {
        setupHighPriorityHandler();
      }
    );
  }

  // Dodajemo i setInterval umesto setTimeout za kontinuirano osiguranje
  setTimeout(function () {
    setupHighPriorityHandler();
  }, 500);

  // Za stranice telefona i stranice sa većim vremenskim odlaganjem u učitavanju
  setTimeout(function () {
    setupHighPriorityHandler();
  }, 1500);

  // MutationObserver koji prati promene u DOM-u i reaguje kad se dodaju novi elementi
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        // Proveravamo da li su dodate strelice
        var hasArrows = false;
        mutation.addedNodes.forEach(function (node) {
          if ($(node).find(".image-wrapper--arrow").length > 0) {
            hasArrows = true;
          }
        });

        if (hasArrows) {
          setupHighPriorityHandler();
        }
      }
    });
  });

  // Pokreni observer da prati promene u body elementu
  observer.observe(document.body, { childList: true, subtree: true });
});
